var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartHorizontalBar',{attrs:{"datasets":_vm.defaultDatasets,"labels":"['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']"}})}
var staticRenderFns = []

export { render, staticRenderFns }